import "./Transaction.scss";
export const TransactionInput = ({
  value,
  type,
  disabled,
  handleInputChange,
  InputOnFocus,
  onBlur,
  jvTransactions,
  name,
  onFocus,
}) => {
  return (
    <input
      InputConfig=""
      className={jvTransactions ? "transactionInput no-spinners jvTransaction" : "transactionInput no-spinners"}
      value={value}
      type={type}
      disabled={disabled}
      onChange={(e) => handleInputChange(e)}
      onBlur={onBlur}
      name={name}
      onFocus={onFocus}
    />
  );
};
